import { useEffect } from 'react';
import { useCurrentUserId, useUserType } from '@framework/auth';
import type { GroupId, GroupMemberInvitationId } from 'balus-common';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { Navigate } from 'react-router';
import { InvitationContent } from './InvitationContent';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';
import { useGroupMyMemberRole } from '@group/hooks/useGroupMyMemberRole';

type Props = {
  groupId: GroupId;
  invitationId: GroupMemberInvitationId;
  token: string | null;
};

export const PageContent: React.FC<Props> = ({ groupId, invitationId, token }: Props) => {
  const currentUserId = useCurrentUserId();
  const role = useGroupMyMemberRole(groupId);
  const userType = useUserType();

  useEffect(() => {
    // 匿名ユーザーでログイン済みの状態であれば一度ログアウトさせる
    if (userType === 'anonymous') {
      FirebaseAuthenticationClient.signOut();
    }
  }, [userType]);

  // 参加済みグループへの招待を開いた場合は招待ページを開かずにそのグループのページにリダイレクトする
  if (currentUserId && role) {
    return <Navigate to={UserPagePathBuilder.groupPage(groupId)} replace />;
  }

  return <InvitationContent groupId={groupId} invitationId={invitationId} token={token} />;
};
